
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Util, getPageAPIs } from "@/common/util";
// import { CouponsManageAPI } from "@/common/api/couponList";
import ShopAlipayQrcodeAuthAPI from '@/common/api/operationManage/shopAlipayQrcodeAuth';

import { DeepLoop } from "@/common/deepLoop/deepLoop";
import { CommonApi } from "@/common/api/common";

// import ZlSelect from "@/components/third-custom-components/select";

// import ZlOption from "@/components/third-custom-components/option";

import {
  shareConfirmOptions
} from '@/common/config'

export const pageApiList = getPageAPIs(ShopAlipayQrcodeAuthAPI)

const defaultForms = {
  id: '',
  name: '',
  qrcode_url: '',
  image_id: '',
  is_popup: 0,
  notes: '',
  // venue_id: "",
  // venue: {
  //   id: "",
  //   name: "",
  // },
  // singleMaxCountType: '0',
  // shop_id: "",
  // maxLimitCount: ''
};

// const defaultSearchVenuePageOption = {
//   page: 1,
//   limit: 10,
//   isRearchBottom: false,
// };

const saleMachineDialogTitle2ch: any = {
  "new-shop-alipay-qrcode": "新增",
  "edit-shop-alipay-qrcode": "编辑",
};

// 最大有效期
// const maxExpiredDays = 9999;

// 最大时长 单位分钟
// const maxTimeDuration = 24 * 60;

const maxBenefitRate = 100

@Component({
  components: {
    // ZlSelect,
    // ZlOption,
  },
})
export default class ShopAlipayQrcodesManage extends Vue {
  private form: any = {
    // saleMachineId: "",
    shop_name: "",
    id: '',
    // machine_number: '',
    // time: [],
    // startDate: "",
    // endDate: "",
  };
  private forms: any = {
    // maxType: "0",
    // ...defaultForms
  };

  private deepLoopUtil: any = {};
  private commonApi: any;


  // private merchantApi: any;

  private shopAlipayQrcodeAuthApi = new ShopAlipayQrcodeAuthAPI();

  private get isShowFormsNotes() {
    const forms = this.forms

    const {
      image_id,
      qrcode_url,
      is_popup
    } = forms || {}

    if (image_id && qrcode_url && is_popup !== 1) {
      return true
    }

    return false
  }

  private onAutoPlusNotes() {
    this.$set(this.forms, 'notes', '支付认证已与通联支付确认')
  }

  @Watch("isShowFormsNotes")
  private onChangeisShowFormsNotes(val: boolean) {
    if (!val) {
      this.$set(this.forms, 'notes', "")
    }
  }

  // private saleMachineTimeDurationAPI = new ShopAlipayQrcodeTimeDurationManageAPI();
  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();
     this.commonApi = new CommonApi();

    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    // this.searchVenuePageOption = {
    //   ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
    // };

    // this.merchantApi = new MerchantApi();
  }

  
  private created(): void {
    this.getShopAlipayQrcodes();

    // this.refreshShopAlipayQrcodeTimeDurations();

    // this.refreshTableClass();
  }
  private restForm(): void {
    this.form = new Util().clearObject(this.form);

    this.getShopAlipayQrcodes();
  }
  //搜索
  private search(): void {
    this.tablePage.page = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getShopAlipayQrcodes();
  }

  private tableData: any[] = [];

  //dialog
  // private dialogFormVisible: boolean = false;
  private formLabelWidth: string = "100px";
  
  private tablePage: any = {
    count: 0,
    page: 1,
    prepage: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
    totalPage: 0,
  };
  // //翻页
  private handlePageChange(val: any) {
    this.tablePage.page = val.currentPage;
    this.tablePage.prepage = val.pageSize;
    this.getShopAlipayQrcodes();
  }

  private imagePicUploading: boolean = false;

  private handleUploadQrcodeImagePic(file: any, fileList: any[]) {
    console.log(file, fileList, "file", "fileList");

    this.imagePicUploading = true;
    this.commonApi.getOss(
      file instanceof File ? file : file.raw,
      (res: any) => {
        console.log(res, "res 图片上传成功");

        const { data } = res;

        const { data: callbackData } = data;

        const { item: uploadImgObj } = callbackData || {};

        const { id, url } = uploadImgObj;

        this.$set(this.forms, "image_id", id);
        this.$set(this.forms, "qrcode_url", url);

        this.imagePicUploading = false;
      },
      () => {
        this.$message.error("图片上传失败");

        this.imagePicUploading = false;
      }
    );
  }


  private addOrUpdateShopAlipayQrcodeTitle: string = "阿里支付认证二维码";

  private dialogFormVisible: boolean = false;

  // 拉起阿里支付认证二维码弹框
  private handleWakeShopAlipayQrcodeDialog(mode: string) {
    // if (mode == 'new-shop-alipay-qrcode') { // 新增阿里支付认证二维码

    // }
    this.saleMachineDialogMode = mode;
    this.addOrUpdateShopAlipayQrcodeTitle = saleMachineDialogTitle2ch[mode] || "阿里支付认证二维码";

    this.initShopAlipayQrcodeForm(mode);

    this.dialogFormVisible = true;
  }

  private currentShopAlipayQrcodeItem: any = null;

  private saleMachineDialogMode: string = "";

  private async initShopAlipayQrcodeForm(mode: string) {
    const forms: any = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    if (mode == "edit-shop-alipay-qrcode") {
      // 编辑
      // await this.getMoreVenueList(true);

      // await this.refreshShopAlipayQrcodeTimeDurations();

      // await this.refreshTableClass();

      const currentShopAlipayQrcodeItem = this.currentShopAlipayQrcodeItem;

      const {
        id = '',
     
        name = '',
        qrcode_url = '',
        qrcode_id = '',
        is_popup,
       
      } = currentShopAlipayQrcodeItem || {};

      Object.assign(forms, {
        id,
        name,
        qrcode_url,
        image_id: qrcode_id,
        is_popup
      })


      

      forms.id = id;
    }

    console.log(forms, "forms");

    // console.log(this.venueList, "this.venueList");

    this.forms = forms;
  }

  private handleWakeEditShopAlipayQrcodeDialog(saleMachineItem: any) {
    this.currentShopAlipayQrcodeItem = saleMachineItem;

    this.handleWakeShopAlipayQrcodeDialog("edit-shop-alipay-qrcode");
  }

  // private handleDelteShopAlipayQrcodeDialog(saleMachineItem: any) {
  //   this.$confirm("确定删除该阿里支付认证二维码?", "", {
  //     ...shareConfirmOptions,
  //   }).then(() => {
  //     this.shopAlipayQrcodeAuthApi.deleteShopAlipayQrcode({
  //       id: saleMachineItem.id
  //     }, () => {
  //       this.getShopAlipayQrcodes()
  //     }, () => {

  //     })
  //   });
  // }

  // private venueList: any[] = [
  //   // {
  //   //   id: 1,
  //   //   label: '测试'
  //   // },
  //   // {
  //   //   id: 2,
  //   //   label: '测试2'
  //   // }
  // ];

  // private searchVenueLoading: boolean = false;

  // private remoteGetVenueQueryString: string = "";

  // private remoteSearchVenueTimer: any = null;

  // private searchVenuePageOption: any = {};

  // private initRemoteGetVenuePageOption() {
  //   this.searchVenuePageOption = {
  //     ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
  //   };
  // }

  // private getSearchVenueParams() {
  //   const searchVenuePageOption = this.searchVenuePageOption;

  //   const remoteGetVenueQueryString = this.remoteGetVenueQueryString;

  //   const { page, limit } = searchVenuePageOption;

  //   const params: any = {
  //     page,
  //     limit,
  //   };

  //   if (remoteGetVenueQueryString && remoteGetVenueQueryString.trim()) {
  //     params.name = remoteGetVenueQueryString.trim();
  //   }

  //   return params;
  // }

  // private getMoreVenueList(refresh: boolean = true) {
  //   return new Promise((resolve: Function, reject: Function) => {
  //     if (refresh) {
  //       this.initRemoteGetVenuePageOption();
  //     }

  //     const params = this.getSearchVenueParams();

  //     this.shopAlipayQrcodeAuthApi.searchVenueList(
  //       params,
  //       (res: any) => {
  //         console.log(res, "res");

  //         const venueList: any[] = res.data || [];

  //         this.venueList = refresh
  //           ? venueList
  //           : this.venueList.concat(venueList);

  //         if (Array.isArray(res.data) && res.data.length == 0) {
  //           this.searchVenuePageOption.isRearchBottom = true;
  //         }
  //         this.searchVenueLoading = false;

  //         this.addVenueListLoading = false;

  //         resolve();
  //       },
  //       () => {
  //         this.searchVenueLoading = false;

  //         this.addVenueListLoading = false;

  //         reject();
  //       }
  //     );
  //   });
  // }

  // // 第一次搜索 无关键字
  // private handleFirstGetVenueList() {
  //   this.searchVenueLoading = true;

  //   this.getMoreVenueList(true);
  // }

  // // 清空搜索
  // private handleClearGetVenueList() {
  //   this.remoteGetVenueQueryString = "";

  //   this.searchVenueLoading = true;

  //   this.getMoreVenueList(true);
  // }

  // // 远程搜索
  // private remoteGetVenueMethod(query: string) {
  //   query = query.trim ? query.trim() : "";

  //   if (query !== "") {
  //     this.remoteGetVenueQueryString = query;
  //     clearTimeout(this.remoteSearchVenueTimer);

  //     this.remoteSearchVenueTimer = setTimeout(() => {
  //       this.searchVenueLoading = true;

  //       this.getMoreVenueList();
        
  //     }, 300);
  //   } else {
  //     this.remoteGetVenueQueryString = "";
  //     this.venueList = [];
  //   }
  // }

  // private addVenueListLoading: boolean = false;

  // private remoteAddVenueMethod() {
  //   if (this.addVenueListLoading) return;
  //   const searchVenuePageOption = this.searchVenuePageOption;

  //   const { isRearchBottom } = searchVenuePageOption;

  //   if (isRearchBottom) return;

  //   this.searchVenuePageOption.page++;

  //   this.addVenueListLoading = true;

  //   this.getMoreVenueList(false);
  // }

  // 分成比例
  // private handleLimitBenefitRate(val: string) {
  //   Util.limitIntegetInput(
  //     val,
  //     (new_val: string) => {
  //       const limit_val = Math.min(Number(new_val), maxBenefitRate).toString();
  //       this.$set(this.forms, "fencheng_rate", limit_val);
  //     },
  //     (new_val: string) => {
  //       this.$set(this.forms, "fencheng_rate", new_val);
  //     }
  //   );
  // }

  // private handleLimitSingleMaxCount(val: string) {
  //   Util.limitIntegetInput(
  //     val,
  //     (new_val: string) => {
  //       this.$set(this.forms, "maxLimitCount", new_val);
  //     },
  //     (new_val: string) => {
  //       this.$set(this.forms, "maxLimitCount", new_val);
  //     }
  //   );
  // }

  private sumbitShopAlipayQrcodeLoading: boolean = false;

  // 提交阿里支付认证二维码配置
  private handleSumbitShopAlipayQrcode() {
    const saleMachineDialogMode = this.saleMachineDialogMode;

    const params = this.getShopAlipayQrcodeFormsParams(saleMachineDialogMode);

    console.log(params, "params");
    if (params === false) return;

    this.sumbitShopAlipayQrcodeLoading = true;
    switch (saleMachineDialogMode) {
      case "new-shop-alipay-qrcode":
        // this.shopAlipayQrcodeAuthApi.addShopAlipayQrcode(
        //   params,
        //   () => {
        //     this.getShopAlipayQrcodes();
        //     this.dialogFormVisible = false;
        //     this.sumbitShopAlipayQrcodeLoading = false;
        //   },
        //   () => {
        //     this.sumbitShopAlipayQrcodeLoading = false;
        //   }
        // );
        break;
      case "edit-shop-alipay-qrcode":
        this.shopAlipayQrcodeAuthApi.updateShopAlipayQrcode(
          params,
          () => {
            this.getShopAlipayQrcodes();
            this.dialogFormVisible = false;
            this.sumbitShopAlipayQrcodeLoading = false;
          },
          () => {
            this.sumbitShopAlipayQrcodeLoading = false;
          }
        );
        break;
    }
  }

  private getShopAlipayQrcodeFormsParams(mode: string) {
    const params: any = {};

    const showErrorMessage = (msg: string) => {
      if (!!msg) {
        this.$message.error(msg);
      }
    };

    const forms = this.forms;

    const {
      id,
      // name,
      // expired_days,
      // meituanId,
      // timeDuration
      // machine_number,
      is_popup,
      image_id,
      notes = ''
    } = forms || {};

    

    // const keys = ["machine_number", "fencheng_rate"];

    // const key2EndKey: any = {
    //   machine_number: "machine_number",
    //   fencheng_rate: "fencheng_rate",
    // };

    // const key2ErrMsg: any = {
    //   machine_number: "设备编码不能为空",
    //   fencheng_rate: "分成比例不能为空",
    // };

    // for (let i = 0; i < keys.length; i++) {
    //   const key = keys[i];

    //   if (forms[key]) {
    //     const errMsg = key2ErrMsg[`${key}_${forms[key]}`];
    //     if (errMsg) {
    //       showErrorMessage(errMsg);

    //       return false;
    //     }
    //     params[key2EndKey[key] || key] = forms[key];
    //   } else {
    //     showErrorMessage(key2ErrMsg[key]);

    //     return false;
    //   }
    // }

    Object.assign(params, {
      is_popup
    })

    if (image_id) {
      params.qrcode_id = image_id
    }
    

    if (this.isShowFormsNotes) {
      Object.assign(params, {
        notes
      })
    }

    

    if (mode == "edit-shop-alipay-qrcode") {
      params.shop_id = id;
    }

    return params;

  }

  //获取售货机列表
  private getShopAlipayQrcodes(): void {
    this.shopAlipayQrcodeAuthApi.getShopAlipayQrcodeList(
      { ...this.getShopAlipayQrcodeParams() },
      (res: any) => {
        // res.data.list
        this.tableData = res.data.list;
        this.tablePage.page = res.data.page;
        this.tablePage.prepage = res.data.prepage;
        // this.tablePage.totalPage = res.data.total;
        this.tablePage.count = res.data.count;
      },
      () => {}
    );
  }

  private getShopAlipayQrcodeParams(): any {
    const params: any = {};

    const form = this.form;

    const tablePage = this.tablePage;

    const { page, prepage } = tablePage;

    const { shop_name, id } = form;

    if (shop_name) {
      params.shop_name = shop_name;
    }

    if (id) {
      params.id = id
    }


    if (page) {
      params.page = page;
    }

    if (prepage) {
      params.limit = prepage;
    }

    return params;
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }

  private selectPage: any = {
    page: 1,
    prepage: 200,
    totalPage: 0,
    count: 0,
  };
}
